import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUp, ArrowDown, Minus, Sparkles } from "lucide-react";
import PageLayout from "../../components/layout/PageLayout";
import TrendingBar from "../../components/football/TrendingBar";
import { HERO_IMAGES } from "../../lib/constants";
import api from "../../lib/api";

const MOVE_ICON = { up: ArrowUp, down: ArrowDown, same: Minus, new: Sparkles };
const MOVE_CLASS = { up: "text-emerald-400", down: "text-red-400", same: "text-white/40", new: "text-[#d4af37]" };

export default function HighSchoolTop50() {
    const [teams, setTeams] = useState([]);
    useEffect(() => { api.get("/football/hs/rankings").then(r => setTeams(r.data)).catch(() => {}); }, []);

    return (
        <PageLayout>
            <section className="relative pt-28 pb-12 border-b border-white/10 overflow-hidden">
                <img src={HERO_IMAGES.huddle} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
                <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-5">Digital Beast High School Top 50</div>
                    <h1 className="font-display text-5xl md:text-7xl text-white leading-[0.9] tracking-tight" data-testid="hs-heading">
                        THE 50 PROGRAMS<br/><span className="text-[#d4af37]">EVERY FAN SHOULD KNOW.</span>
                    </h1>
                    <p className="text-white/60 mt-4 max-w-2xl">Editor-maintained rankings. Movement indicators show week-over-week change. Ranking positions 16–50 will populate as Digital Beast editors publish.</p>
                </div>
            </section>
            <TrendingBar />

            <section className="py-14" data-testid="hs-rankings">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 space-y-3">
                    {teams.map(t => {
                        const MoveIcon = MOVE_ICON[t.movement] || Minus;
                        return (
                            <Link key={t.id} to={`/football/high-school/${t.slug}`}
                                className="surface surface-hover flex flex-col md:flex-row gap-4 md:gap-6 p-5 items-start md:items-center" data-testid={`hs-rank-${t.rank}`}>
                                <div className="font-display text-6xl md:text-7xl text-[#d4af37] leading-none w-16 md:w-20">#{t.rank}</div>
                                {t.hero_image && <div className="w-full md:w-32 h-24 overflow-hidden"><img src={t.hero_image} alt="" className="w-full h-full object-cover opacity-70" /></div>}
                                <div className="flex-1">
                                    <div className="font-display text-2xl md:text-3xl text-white leading-tight">{t.school}</div>
                                    <div className="text-white/50 text-xs uppercase tracking-widest mt-2">{t.city}, {t.state}</div>
                                    <div className="text-white/70 text-sm mt-2">Record: {t.record || "—"} · Coach: {t.coach || "—"}</div>
                                </div>
                                <div className={`flex items-center gap-2 ${MOVE_CLASS[t.movement]} text-xs uppercase tracking-widest`}>
                                    <MoveIcon size={14} />
                                    <span>{t.movement === "new" ? "NEW" : t.movement === "same" ? "—" : `was #${t.previous_rank}`}</span>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </section>
        </PageLayout>
    );
}
